module.exports = __webpack_public_path__ + "static/media/pdf.b8814372.svg";